import { Icon } from "@customer-tools-web/component-ui";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { MenuItemType, TrackMenuType } from "../Header";

import { Menu_Keys_Type } from "./Menus";

type Props = {
  title: string | React.ReactNode | undefined;
  keyName: Menu_Keys_Type;
  trackMenuTap: TrackMenuType | undefined;
};

export const SubMenuWithForm = (props: Props) => {
  const { title, keyName, trackMenuTap } = props;
  const trackMenuTapWithCurrentUrl = (
    (currentUrl: string) => (menuName: MenuItemType["key"]) =>
      trackMenuTap && trackMenuTap(menuName, currentUrl)
  )(window.location.pathname);
  const path = (process.env.REACT_APP_URL_PREFIX || "") + `/${keyName}`;

  return (
    <Link
      to={`${path}`}
      target="_blank"
      onClick={() => trackMenuTapWithCurrentUrl(keyName)}
    >
      {title}
      <MenuIcon type="external-link-lg" />
    </Link>
  );
};

const MenuIcon = styled(Icon)`
  :first-child {
    padding-right: 11px;
    padding-left: 11px;
    font-size: ${(props) => props?.theme?.fontSize?.small};
  }
  :last-child {
    padding-left: 5px;
  }
  size: 14px;
  color: ${(props) => props.theme.textDeepGray};
`;
